import { memo } from 'react'
import { usePlaybackPosition } from '@/hooks/usePlaybackPosition'

function PlaybackLine() {
  const { position } = usePlaybackPosition()

  return (
    <div
      style={{ left: position }}
      className="pointer-events-none absolute z-40 h-full w-px bg-red-500"
    />
  )
}

export default memo(PlaybackLine)
